import { Grid } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../../shared/FormTextField';
import ItineraryAddressFields from './ItineraryAddressFields';

const EventForm = () => {
    const { control } = useFormContext();
    return (
        <Grid container item spacing={2}>
            <Grid item xs={12}>
                <FormTextField
                    name='itineraryItemInfo.title'
                    control={control}
                    label='Event Title'
                />
            </Grid>
            <Grid container item spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name='itineraryItemInfo.venue'
                        control={control}
                        label='Venue'
                        placeholder='e.g. Convention Center'
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name='itineraryItemInfo.dressCode'
                        control={control}
                        label='Dress Code'
                        placeholder='e.g. Business casual'
                    />
                </Grid>
            </Grid>
            <ItineraryAddressFields
                name='address'
                autocompletePlaceholder='Search address'
                title='Address (Optional)'
            />
        </Grid>
    );
};

export default EventForm;
